import React from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import AnimatedArcs from '../AnimatedArcs';
import cn from 'classnames';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface INonGatedEbookAsideProps extends IBaseElementProps {
	image?: IImage;
	link?: ILink;
}

const NonGatedEbookAside: React.FC<INonGatedEbookAsideProps> = ({
	className,
	classNames = [],
	id,
	image,
	link,
}) => {
	return (
		<div
			id={id}
			className={
				className ||
				cn(
					'calian-non-gated-right-side position-relative',
					...classNames,
				)
			}
		>
			<div className="calian-non-gated-right-side--content z-1 position-relative">
				{image && (
					<div className="webinar-hero__featured-image">
						<Image {...image} />
					</div>
				)}
				{link && (
					<Button
						{...link}
						icon="download"
						classNames={['mt-md-6 mt-4 d-inline-flex gap-2']}
						type="secondary"
					/>
				)}
			</div>
			<div className="z-0 position-absolute end-0 bottom-0 w-100 h-100">
				<AnimatedArcs
					arcsStyle={'Hero - Three Lines'}
					arcsPosition="Right"
					arcOneColor="var(--bs-primary)"
					arcOneStrokeWidth={4}
					arcTwoColor="var(--bs-primary)"
					arcTwoStrokeWidth={3}
					animationDelay={1000}
					animationOffset={150}
				/>
			</div>
		</div>
	);
};

export default NonGatedEbookAside;
